export const SITE_ORIGIN = 'https://www.zeedcom.com';
export const SITE_INSTAGRAM = 'https://www.instagram.com/zeedcom_solution/';
export const SITE_EMAIL = 'contact@zeedcom.com';
export const SITE_OG_IMAGE = `${SITE_ORIGIN}/og-image.png`;

export function siteUrl(pathname: string): string {
  if (!pathname || pathname === '/') return `${SITE_ORIGIN}/`;
  const withSlash = pathname.startsWith('/') ? pathname : `/${pathname}`;
  const trimmed = withSlash.replace(/\/+$/, '');
  return `${SITE_ORIGIN}${trimmed}/`;
}
